import { Route, Outlet } from 'react-router-dom';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { ProtectedRoute } from 'ProtectedRoute';
import { type CurrentUser, getCohort } from 'Users';
import { getProgramConfigValue } from 'Program';

export const TUTORBOT_AI_ADVISOR_ROUTES = {
    BOT: { path: '/bot' },
};

export function configureTutorBotAiAdvisorRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: TUTORBOT_AI_ADVISOR_ROUTES,
            config: {},
        },
    ];
}

export function hasBotPageAccess({ currentUser }: { currentUser: CurrentUser }) {
    const cohort = getCohort(currentUser);
    if (!cohort) return false;

    return !!getProgramConfigValue(cohort.programType, 'supportsBotPage');
}

async function getLazyTutorbotComponent() {
    const { BotPage } = await import(/* webpackPrefetch: true */ './BotPage/BotPage');
    return {
        Component: () => (
            <ProtectedRoute accessPolicy="custom" accessPolicyFn={hasBotPageAccess}>
                <BotPage />
            </ProtectedRoute>
        ),
    };
}

export function getTutorBotAiAdvisorRoutes() {
    return (
        <Route id="tutorbot-ai-advisor-routes" element={<Outlet />}>
            <Route path={TUTORBOT_AI_ADVISOR_ROUTES.BOT.path} lazy={getLazyTutorbotComponent} />
        </Route>
    );
}
